import { inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { UtilService } from 'src/app/services/util.service';
import { ModelPriceComponent } from '../../Price-subscritions/model-price/model-price.component';
import { BENEFITS_KEY } from '../../Price-subscritions/priceplanService';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';


export type TEXT_FIELDS = {
  label : string ,
  key : string ,
  value : any,
  dropdownView : boolean,
  disabled : boolean,
  validate : boolean,
  required : boolean,
  route : boolean,
  min : number,
  max : number,
  minText : string,
  path : string,
  requiredText : string,
  maxText : string,
  pattern : string,
  patternText : string,
  type : "DATE" | "BOOLEAN" | "STRING"|"LIST",

}

export type teamMembers = {
  teamId: string,
  userId: string,
  connectionStatus: any
}

export type businessNetworkMembers = {
  businessNetworkId: string,
  businessNetworkName: string,
  status: any,
  userId: any,
}

export type ROLE_TYPES = "SUPERADMIN" | "ADMIN" | "EMPLOYEE"

export type CUSTOMER_MENU_ITEMS = "plan" | "user" | "interaction" | "jobs" | "workSpace" |
 "businessNetworks" | "businessContacts" | "network" | "contacts" | "analytics" | "billing" |
  "details" | "userDetails" | "business-jobs" | "business-candidates" | "business-applicants" | "publishSettings";


type FILTER_OBJ = {value : any , key : CUSTOMER_MENU_ITEMS};


@Injectable({
  providedIn: 'root'
})
export class CustomerService {
  router = inject(Router);
  private currentUrl: string;
  private filterPayloadSubject = new BehaviorSubject<any>(null);
  filterPayload$ = this.filterPayloadSubject.asObservable();
  private previousUrl: string;

  constructor() {

    this.currentUrl = this.router.url;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
      };
    });
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // Check if the new URL is the same as the current one (ignoring query parameters)
        const currentUrlWithoutQueryParams = this.removeQueryParams(event.url);
        const lastUrlWithoutQueryParams = this.urlHistory.length > 0
                                          ? this.removeQueryParams(this.urlHistory[this.urlHistory.length - 1])
                                          : null;

        // Only push the URL if it is different from the last one
        if (currentUrlWithoutQueryParams !== lastUrlWithoutQueryParams) {
          this.urlHistory.push(event.url);
        }
      }
    });
   }
   private urlHistory: string[] = [];
  private userData : Array<any> = [];
  private singleUserData : Array<any> = [];
  private planDetails : any[] = [];
  private refreshSubject = new Subject<CUSTOMER_MENU_ITEMS>();
  private filterSubject = new Subject<FILTER_OBJ>();
  private searchSubject = new Subject<FILTER_OBJ>();
  private openSlotModal = new Subject<FILTER_OBJ>();

  // getPreviousUrl(){
  //   return this.previousUrl;
  //  }
  removeQueryParams(url: string): string {
    return url.split('?')[0]; // Only return the part of the URL before the "?"
  }

  getPreviousUrl(): string | null {
    this.urlHistory.pop(); // Remove the current URL
    return this.urlHistory.length > 0 ? this.urlHistory[this.urlHistory.length - 1] : null;
  }
  emitRefresh(val : CUSTOMER_MENU_ITEMS){
    this.refreshSubject.next(val);
  }

  getRefreshKey() : Observable<CUSTOMER_MENU_ITEMS> {
    return this.refreshSubject.asObservable();
  }
  isBusinessOrEnterprise(memberShipType: string): boolean {
    return [GigsumoConstants.StarterPlan , GigsumoConstants.GrowthPlan ,GigsumoConstants.ScaleXPlan].includes(memberShipType);
  }
  redirectToUpgrade() {
    this.router.navigate(['/plan-quota']);
  }

  emitFilter(val : FILTER_OBJ){
    this.filterSubject.next(val);
  }

  getFilterValue() : Observable<FILTER_OBJ> {
    return this.filterSubject.asObservable();
  }

  emitSearch(val : FILTER_OBJ){
    this.searchSubject.next(val);
  }

  getSearchValue() : Observable<FILTER_OBJ> {
    return this.searchSubject.asObservable();
  }

  setUserData(v) : void{
    this.userData = v;
  }

  getUserData() : Array<any>{
   return this.userData;
  }

  openSlotModals(v : FILTER_OBJ) : void{
    this.openSlotModal.next(v);
  }

  getSlotModal() : Observable<FILTER_OBJ>{
   return this.openSlotModal;
  }

  setUser(v) : void{
    this.singleUserData = v;
  }

  getUser() : Array<any>{
   return this.singleUserData;
  }

async getupdatedplans(businessId : string ){
    const userPlan: any = await this.API.lamdaFunctionsget('findBusinessPlanBenefits/' + businessId);
    return userPlan.data != null ? userPlan.data.businessPlanAndBenefits : null;

}
  findPlan(key : BENEFITS_KEY){
    if(this.planDetails){
      return this.planDetails.find(x => x.benefitKey === key);
    }
  }

  modalService = inject(BsModalService);
  utilService = inject(UtilService);
  ref: BsModalRef;
  planvalidationpopup(plan, selecteditem) {
    const initialState: any = {
      backdrop: 'static',
      keyboard: false,
      size: "lg",
      title : selecteditem ,
      planDetails : plan
    };
    this.utilService.startLoader();
    this.ref = this.modalService.show(ModelPriceComponent, {initialState});
    this.utilService.stopLoader();
  }

  closeRef(){
    this.ref.hide();
  }

  API = inject(ApiService);
  async getUserPLanBenefits(userId: string , KEY : BENEFITS_KEY) {
    const userPlan: any = await this.API.lamdaFunctionsget('findUserPlanBenefits/' + userId);
    const plan = userPlan.data.userPlanAndBenefits.benefitsUsages;
    const membershipType = userPlan.data.userPlanAndBenefits.membershipType;
    if (plan) {
      const planData = plan.find(x => x.benefitKey as BENEFITS_KEY ===  KEY);
      return {
        ...planData,
        membershipType : membershipType
      }
    }
  }


  async getBusinessPLanBenefits(id , KEY :BENEFITS_KEY) {
    const userPlan: any = await this.API.lamdaFunctionsget('findBusinessPlanBenefits/' + id);
    const plan = userPlan.data.businessPlanAndBenefits.benefitsUsages;
    const membershipType = userPlan.data.businessPlanAndBenefits.membershipType;
    if (plan) {
      const planData = plan.find(x => x.benefitKey as BENEFITS_KEY ===  KEY);
      return {
        ...planData,
        membershipType : membershipType
      }
    }
  }
  setFilterPayload(payload: any) {
    this.filterPayloadSubject.next(payload || null);
  }
  resetFilterPayload() {
    this.filterPayloadSubject.next(null);  // Reset the payload to null explicitly
  }

  getFilterPayload() {
    return this.filterPayloadSubject.getValue();
  }

}
